import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MarketingFooter } from './MarketingFooter';

const ROUTE_TITLES: Record<string, string> = {
  '/': 'RoleForgeAI - AI Workforce Blueprint',
  '/blueprint': 'AI Workforce Blueprint - RoleForgeAI',
  '/checkout': 'Checkout - RoleForgeAI',
  '/thanks': 'Your Blueprint is ready - RoleForgeAI',
  '/oto': 'Your free upgrade - RoleForgeAI',
  '/course-offer': 'Implementation course - RoleForgeAI',
};

export function MarketingLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = ROUTE_TITLES[pathname] ?? 'RoleForge';
    // SPA navigations don't reset scroll, so a funnel step reached by client-side
    // navigation (e.g. /checkout → /oto after payment) would otherwise open at
    // whatever scroll offset the previous page left. Every funnel surface starts
    // at the top.
    window.scrollTo(0, 0);
  }, [pathname]);

  // Marketing surfaces are dark-only. The audit experience under /audits/:id
  // continues to respect the user's theme preference; this scoped attribute
  // doesn't leak past the marketing route subtree.
  return (
    <div data-theme="dark" className="relative min-h-screen flex flex-col overflow-hidden bg-[#080a0f] text-white antialiased">
      {/* Brand glow — three diffuse coral-red circles wash across the viewport,
          matching the login surfaces on CRM, Sites, and Core. Brand color
          #fe5963 is sampled from the RoleForge icon SVG. */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute top-[-80px] left-[-60px] w-96 h-96 rounded-full bg-[#fe5963]/[0.18] blur-3xl"></div>
        <div className="absolute bottom-[-60px] left-1/3 w-72 h-72 rounded-full bg-[#fe5963]/[0.10] blur-3xl"></div>
        <div className="absolute top-1/4 right-[-80px] w-80 h-80 rounded-full bg-[#fe5963]/[0.08] blur-3xl"></div>
      </div>

      <main className="relative flex-1">
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
}
